import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { DataAccessService } from '../data-access.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private userData: any;
  private userDataSource = new BehaviorSubject<any>(null);

  constructor(private dataAccessService: DataAccessService) {
    // super();
  }

  get userData$(): Observable<any> {
    return this.userDataSource.asObservable();
  }

  getUserData(email: any): Observable<any> {
    email = localStorage.getItem('email');
    // console.log(email);
    return this.dataAccessService.userData.getUserData(email).pipe(
      tap((response) => {
        // console.log(response);
        this.user = response;
        // console.log(this.user.userData);
        localStorage.setItem('roleID',this.user.userData.roleID.toString());
        localStorage.setItem('IsApprover',this.user.userData.isApprover);
        localStorage.setItem('IsL1',this.user.userData.isL1);
        localStorage.setItem('IsL2',this.user.userData.isL2);
        localStorage.setItem('IsRequestor',this.user.userData.isRequestor);
        this.userDataSource.next(response);
      }),
      map((_) => {
        return this.user;
      }),
      catchError((error) => {
        this.user = null;

        return throwError(error);
      })
    );
  }

  isUserSessionReady(requiredRolesIds: Array<any> = null): boolean {
    return this.userData ? requiredRolesIds.includes(this.userData.roleID) : false;
  }

  get user(): any {
    return this.userData;
  }

  set user(userData: any) {
    this.userData = userData;
    this.userDataSource.next(userData)
  }

  get isAddRequestsPermissionAvailable(): boolean {
    return this.user.isAddRequests;
  }

  get isApproveRequestsPermissionAvailable(): boolean {
    return this.user.isApproveRequests;
  }
}
